const data = {
  id: 1,
  title: 'Read and choose the correct answer.',
  subTitle: 'Đọc và chọn đáp án đúng.',
  questionText: 'Phong studies at Nguyen Du Primary school. Every day he gets up at 6.30. He goes to school at 7 a.m. School starts at 7.30 a.m. and finishes at 4.30 p.m. He goes home at 5 o’clock. He has dinner at 7.15 in the evening. Then he does his homework or listens to music. He goes to bed at 9.45.',
  question: '1. Phong ___ at 7:15.',
  answers: [
    { id: 1, answer: 'gets up', isCorrect: false },
    { id: 2, answer: 'goes to school', isCorrect: false },
    { id: 3, answer: 'has dinner', isCorrect: true },
  ],
  settings: {
    answers: {
      // direction: 'horizontal',
      direction: 'horizontal',
    },
  },
};

export default data;
